export default "/images/2e4dc207e8bae2066d5060dbab7dbd4b.avif";